import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

// Create a separate base API for background processes with its own base URL
const backgroundProcessBaseQuery = axiosBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_API_URL || 'https://stg-api.siswamedia.com',
});

// Base query with error handling
const backgroundProcessBaseQueryWithErrorHandling = async (args, api, extraOptions) => {
  const result = await backgroundProcessBaseQuery(args, api, extraOptions);

  // Handle common error cases
  if (result.error) {
    if (result.error.status === 401) {
      console.error('Unauthorized access - token might be expired');
    }
    if (result.error.status === 'FETCH_ERROR') {
      console.error('Network error - check your connection');
    }
  }

  return result;
};

export const backgroundProcessesApi = createApi({
  reducerPath: 'backgroundProcessesApi',
  baseQuery: backgroundProcessBaseQueryWithErrorHandling,
  tagTypes: ['BackgroundProcess'],
  endpoints: (build) => ({
    getBackgroundProcesses: build.query({
      query: (params) => ({
        url: 'v2/bg-processes',
        method: 'GET',
        params,
      }),
      providesTags: (result, error, params) => [{ type: 'BackgroundProcess', params }, 'BackgroundProcess'],
      transformResponse: (response) => ({
        data: response.data || [],
        pagination: response.pagination || {},
        processId: response.processId,
        message: response.message,
        status_code: response.status_code,
      }),
      keepUnusedDataFor: 30,
    }),
    getBackgroundProcessById: build.query({
      query: (id) => ({
        url: `v2/bg-processes/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'BackgroundProcess', id }],
      transformResponse: (response) => response.data,
      keepUnusedDataFor: 30,
    }),
  }),
  overrideExisting: false,
});

export const { useGetBackgroundProcessesQuery, useGetBackgroundProcessByIdQuery } = backgroundProcessesApi;
